$(document).ready(function() {

    // #9779 : Collapse sur les liens "mon compte" en mobile
    if ($('.customer-links__list').length > 0) {

        let max_height_customerlinks = $('.customer-links__list').outerHeight() + 1;
        let height_active_customerlink = ($('.customer-links a.active').length > 0 ? $('.customer-links a.active').outerHeight() + 1 : 0);
        let is_collapse_open = false;
        let has_collapse = false;

        if ($(window).width() < 992) {
            has_collapse = true;
        }

        
        prestashop.on('initAccLinksTriggerActive', function() {
            [max_height_customerlinks, height_active_customerlink] = pliciInitCollapse(max_height_customerlinks, height_active_customerlink);
        });

        var timeoutResizeCollapse = false;

        $(window).resize(function() {

            if (timeoutResizeCollapse !== false) {
                clearTimeout(timeoutResizeCollapse);
            }

            timeoutResizeCollapse = setTimeout(function() {
                var temp_has_collapse = has_collapse;

                if ($(window).width() >= 992) {
                    has_collapse = false;
                } else {
                    has_collapse = true;
                }

                // Quand on passe de bureau à mobile
                if (temp_has_collapse == false && has_collapse == true) {
                    is_collapse_open = false;
                    [max_height_customerlinks, height_active_customerlink] = pliciInitCollapse(max_height_customerlinks, height_active_customerlink, true);
                }

                // Quand on est en bureau
                if (has_collapse == false) {
                    $('.customer-links__list').css('height', '100%');
                }

                // Quand on est en modile et que le collapse est ouvert
                if (has_collapse && is_collapse_open) {
                    setCollapseTo100InPixels();
                }
            }, 200);


        });

        $(document).on('click', '.customer-links a.active', function(e) {
            if ($(window).width() < 992) {

                e.preventDefault();
                if (is_collapse_open) {
                    $('.customer-links a.active').removeClass('collapse-open');
                    $('.customer-links a.active').addClass('collapse-closed');
                    $('.customer-links__list').css('height', height_active_customerlink + 'px');
                } else {
                    $('.customer-links a.active').removeClass('collapse-closed');
                    $('.customer-links a.active').addClass('collapse-open');
                    $('.customer-links__list').css('height', max_height_customerlinks + 'px');

                    // le temps de la transition
                    setTimeout(function() {
                        setCollapseTo100InPixels();
                    }, 300);
                }

                is_collapse_open = !is_collapse_open;
            }
        });
    }
});

function pliciInitCollapse(max_height_customerlinks, height_active_customerlink, from_resize = false) {
    
    if (from_resize) {
        $('.customer-links__list').css('height', '100%');
        max_height_customerlinks = $('.customer-links__list').outerHeight() + 1;
    }

    if ($('.customer-links a.active').length > 0 && $(window).width() < 992) {
        $('.customer-links a.active').addClass('collapse-closed');
        
        max_height_customerlinks = $('.customer-links__list').outerHeight() + 1;
        height_active_customerlink = $('.customer-links a.active').outerHeight() + 1;
        $('.customer-links__list').css('height', height_active_customerlink + 'px'); // On "ferme" le collapse en disant que la taille est la taille du 1er element

        $('.customer-links__list').css('transition', 'height 0.3s ease-in-out');        
    }

    return [max_height_customerlinks, height_active_customerlink];
}

/**
 * Obligé de mettre en pixels pour avoir la transition
 */
function setCollapseTo100InPixels() {
    $('.customer-links__list').css('height', '100%');
    var current_100_height = $('.customer-links__list').outerHeight() + 1;
    $('.customer-links__list').css('height', current_100_height + 'px');
}